<template>
  <div>
    <Modal v-model="showModal"
           title="Conferma cancellazione utente"
    >
      <br />Riassegnare contenuti a:  <br />
      <author-box v-model="id" filter="" />
      <br />
      <button
        class="btn btn-form btn-secondary btn-xs"
        type="button"
        @click.prevent="annulla()"
      >
        Annulla
      </button>
      <button
        class="btn btn-form btn-outline-primary btn-xs"
        type="button"
        @click.prevent="deleteUser()"
      >
        OK
      </button>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import VueModal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import AuthorBox from "@/components/altrama/AuthorBox";

export default {
  components: {
    'Modal': VueModal,
    AuthorBox
  },

  props: ["id","showModal"],

  data() {
    return {
      user_to_delete: 0,
    };
  },
  methods: {
    annulla() {
      this.$destroy();
      this.$emit("close");
      this.showModal = false
    },

    deleteUser: function () {
        const self = this;
        axios({
          method: "delete",
          url: this.$url + "user/reassign",
          headers: this.$config.axiosHeaders(),
          params: {
            user_to_delete: self.user_to_delete,
            user_to_reassign: self.id
          },
        })
          .then(function (response) {
            self.$emit("close", response);
          })
          .catch(function (error) {
            self.$emit("close", error);
            self.$processError(error);
          }).finally(() => {
            self.showModal = false;
          });
    },
  },

  mounted: function () {
    this.user_to_delete = this.id
  },
};
</script>
